import { FC, JSX } from 'react'

type WithProviderPropsTypes<T> = {
  Component: FC<T>
  Provider: FC<ProviderTypes>
}

type ProviderTypes = {
  children: JSX.Element
}

export const WithProvider = <T extends object>({
  Component,
  Provider,
}: WithProviderPropsTypes<T>) => {
  const ComponentWithProvider = (props: T) => {
    return (
      <Provider>
        <Component {...props} />
      </Provider>
    )
  }

  ComponentWithProvider.displayName = `WithProvider(${Component.displayName || Component.name})`

  return ComponentWithProvider
}
